import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, OnInit, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'icc-static-flag',
  templateUrl: './static-flag.component.html',
  styleUrls: ['./static-flag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaticFlagComponent {

    constructor(
        private _elementRef: ElementRef,
        elementRef: ElementRef<HTMLElement>,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
    }

    /**
     * Whether the checkbox is checked.
     */
    @HostBinding('class.icc-checkbox-checked')
    @Input()
    get checked(): boolean {
        return this._checked;
    }
    set checked(value: boolean) {
        const checked = coerceBooleanProperty(value);

        if (checked != this.checked) {
            this._checked = checked;
            this._changeDetectorRef.markForCheck();
        }
    }
    private _checked = false;


    /**
     * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
     * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
     * checkable items. Note that whenever checkbox is manually clicked, indeterminate is immediately
     * set to false.
     */
    @HostBinding('class.icc-checkbox-indeterminate')
    @Input()
    get indeterminate(): boolean {
        return this._indeterminate;
    }
    set indeterminate(value: boolean) {
        this._indeterminate = coerceBooleanProperty(value);
    }
    private _indeterminate = false;

    /** Method being called whenever the label text changes. */
    _onLabelTextChange() {
        // Since the event of the `cdkObserveContent` directive runs outside of the zone, the checkbox
        // component will be only marked for check, but no actual change detection runs automatically.
        // Instead of going back into the zone in order to trigger a change detection which causes
        // *all* components to be checked (if explicitly marked or not using OnPush), we only trigger
        // an explicit change detection for the checkbox view and its children.
        this._changeDetectorRef.detectChanges();
    }

    /** Toggles the `checked` state of the checkbox. */
    toggle(): void {
        this.checked = !this.checked;
    }

    _onInteractionEvent(event: Event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
    }
}
